<!-- <div class="card p-2">
  <span class="feather icon-alert-triangle"></span>
  <p mat-dialog-title style="text-align: center;font-size: 1.4rem;" *ngIf="data.title">{{data.title}}</p>
  <p class="mid-header">Are you sure ?</p>
  <p display-2 style="text-align: center;">{{data.message}}</p>
  <div mat-dialog-actions *ngIf="!btns">
    <button (click)="onConfirm()" class="btn btn-primary me-2">Yes</button>
    <button (click)="onDismiss()" class="btn btn-secondary">No</button>
    <button *ngIf="cnclBTn" (click)="onCancel()" class="btn btn-secondary">Cancel</button>
  </div>
  <div mat-dialog-actions *ngIf="btns">
    <button *ngFor="let btn of btnArr" mat-raised-button color="primary" (click)="onBtn(btn)">{{btn}}</button>
  </div>
</div> -->

<div class="card p-2">
  <span class="feather icon-alert-triangle"></span>

  <p mat-dialog-title *ngIf="data.title" style="text-align: center; font-size: 1.4rem;">
    {{ data.title }}
  </p>

  <p class="mid-header">Are you sure?</p>

  <p style="text-align: center;">{{ data.message }}</p>

  <!-- Dropdown for roles -->
  <mat-form-field *ngIf="data.showDropdown" appearance="fill" style="width: 100%; margin-top: 1rem;">
    <mat-label>Select user</mat-label>
    <mat-select [(value)]="selectedValue">
      <mat-option *ngFor="let role of data.dataList" [value]="role">{{ role.name }}</mat-option>
    </mat-select>
  </mat-form-field>

  <div mat-dialog-actions *ngIf="!btns">
    <button (click)="onConfirm()" class="btn btn-primary me-2" [disabled]="data.showDropdown && !selectedValue">Yes</button>
    <button (click)="onDismiss()" class="btn btn-secondary">No</button>
    <button *ngIf="cnclBTn" (click)="onCancel()" class="btn btn-secondary">Cancel</button>
  </div>

  <div mat-dialog-actions *ngIf="btns">
    <button *ngFor="let btn of btnArr" mat-raised-button color="primary" (click)="onBtn(btn)">{{btn}}</button>
  </div>
</div>
